module.exports = __webpack_public_path__ + "img/bg1.85b38e41.png";